import { gql, QueryHookOptions, TypedDocumentNode } from "@apollo/client";

import {
  GetUsersQuery,
  GetUsersQueryVariables,
} from "src/graphql/anti-fraud/__generated__/graphql.ts";
import { userFragment } from "src/graphql/anti-fraud/fragments/UserFragment";
import { useFetchQuery } from "src/graphql/utils";
import { mapToUser } from "src/mappers/user.mappers";
import { isEmpty } from "src/utils/arrays.utils.ts";

export const getUsersQuery = gql`
  query getUsers {
    users(includeDisabled: true) {
      ...UserFragment
    }
  }
  ${userFragment}
` as TypedDocumentNode<GetUsersQuery, GetUsersQueryVariables>;

export const useGetUsersQuery = (
  options?: QueryHookOptions<GetUsersQuery, GetUsersQueryVariables>
) => {
  return useFetchQuery(getUsersQuery, {
    queryOptions: options,
    isEmpty: (data) => isEmpty(data?.users),
    toData: (data) => data?.users?.map(mapToUser) ?? [],
    uiErrors: {
      fetchError: "FETCH-USERS-ERROR",
    },
  });
};
